import axios from "../axios";

/**
 * Get the current user's contest history
 * GET /api/history
 */
export const getContestHistory = async () => {
  try {
    const response = await axios.get("/contest/history");
    return response.data;
  } catch (error) {
    throw error || "Failed to fetch contest history";
  }
};
